import {setTitle} from "@/app/Beef";

/**
 * Displays information about the account being offline.
 */
Beef.module("SuspendedPage", function(startupOptions) {

    this.View = Backbone.Marionette.ItemView.extend({
        template: require("@/app/SuspendedPage.handlebars"),
        attributes: {class: "row-fluid"},

        modelEvents: { "change": "render" },
        onShow: function() {
            setTitle("Account Access Suspended")
        }
    });

});
